import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import Select from 'react-select';

import ToogleCheckedIncident from './Elements/ToogleCheckedIncident';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

class StaffRfmsReportIncidentFatigueFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: null,
      fatigue_incident_list: [],
      staff_list: [],
      applicabilities_list: [],
      date_start: '',
      date_finish: '',
      fatigue_event: '',
      checked: false,
      modal: false,
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.loadData = this.loadData.bind(this);
    
    this.searchReports = this.searchReports.bind(this);
    this.updateReports = this.updateReports.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.buttonActionPlan = this.buttonActionPlan.bind(this);
    this.showModal = this.showModal.bind(this);
    this.editActionPlan = this.editActionPlan.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = true;
    } else {
      var value = false;
    }
    change[name] = value;
    this.setState(change);
  } 
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aplicabilidade/colaboradores/listagens/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            staff_list: responseJson.data.staffs,
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorios-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            staff_list: responseJson.data.staff_list,
            applicabilities_list: responseJson.data.applicabilities_list,
            fatigue_incident_list: responseJson.data.fatigue_incident_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }
  
  updateReports () {
    this.searchReports(null);
  }

  searchReports(event) {
    if (event !== null) {
      event.preventDefault();
    }
    this.handleAlert('', '', 'open');
    var datasave = {
      staff_ids: this.state.staff_ids,
      applicability_id: this.state.applicability_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      checked: this.state.checked,
      fatigue_event: this.state.fatigue_event,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios-de-fadiga/incidentes-de-fadiga/buscar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {
    var self = this;
    if (row.checked == false) {
      var checked = false;
    } else {
      var checked = true;
    }    
    var botao = (
      <div className="btn-group">
        <ToogleCheckedIncident updateReports={self.updateReports} handleAlert={self.handleAlert} RequestApi={self.refs.request_api} report_incident={row} actual_checked={checked} />
      </div>
    );

    return botao;
  }

  buttonActionPlan (cell, row) {
    var botao = (
      <button className="btn btn-info button-inline" title={this.locale.general.editar} onClick={this.showModal.bind(this, row)}><i className="fa fa-fw fa-align-left"></i></button>
    );

    return botao;
  }

  showModal(data, event) {
    this.setState({ id: data.id, action_plan: data.action_plan, plan_fatigue_event: data.fatigue_event, modal: true});
  }

  editActionPlan(event) {
    event.preventDefault();
    var self = this;
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      action_plan: this.state.action_plan,
    };
    var url = '/reporte/voluntario/acao';
    if (this.state.plan_fatigue_event !== 5) {
      var url = '/relatorio-de-fadiga/tripulante/acao';
    }
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateReports();
          self.setState({ modal: false, id: '', action_plan: '', plan_fatigue_event: '' });
          self.handleAlert('', '', 'closed');
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

    render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchReports}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
                required
              />
            </div>
          </div>
          {this.state.applicability_id == 2 ?
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.Mecanicos}:</label>
                  <Select
                    className="form-field-name"
                    name="staff_ids"
                    value={this.state.staff_ids}
                    searchable={true}
                    placeholder={this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarMecanicos}
                    onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                    options={this.state.staff_list}
                    multi={true}
                  />
                </div>
              </div>
            </div>
            : this.state.applicability_id == 3 ?
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.Coordenadores}:</label>
                  <Select
                    className="form-field-name"
                    name="staff_ids"
                    value={this.state.staff_ids}
                    searchable={true}
                    placeholder={this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarCoordenadores}
                    onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                    options={this.state.staff_list}
                    multi={true}
                  />
                </div>
              </div>
            </div>
            :
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.Tripulantes}:</label>
                  <Select
                    className="form-field-name"
                    name="staff_ids"
                    value={this.state.staff_ids}
                    searchable={true}
                    placeholder={this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarTripulantes}
                    onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                    options={this.state.staff_list}
                    multi={true}
                  />
                </div>
              </div>
            </div>  
          }
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.TipoDeEventoIncidente}:</label>
              <Select
                className=""
                name="fatigue_event"
                value={this.state.fatigue_event}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarIncidente}
                onChange={this.handleSelectChange.bind(this, 'fatigue_event')}
                options={this.state.fatigue_incident_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.ApenasIncidentesDeFadigaChecados}?</label>
              <br/>
              <Toggle
                checked={this.state.checked}
                aria-label='No label tag'
                name="checked"
                onChange={this.handleToggleChange.bind(this, 'checked')} />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.botaoProcurarRelatorios}</button>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tituloListaDeEventosIncidentesDeFadiga}</h3>
      <hr/>
      {self.state.data !== null ? 
        <div>
          <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.semEventosIncidentesDeFadiga}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

            <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}  width='65'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.ID}</TableHeaderColumn>

            <TableHeaderColumn dataField="fatigue_event_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.TipoDeEvento}</TableHeaderColumn>

            <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Data}</TableHeaderColumn>

            <TableHeaderColumn dataField="revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='70'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Revisao}</TableHeaderColumn>

            <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='240'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Tripulante}</TableHeaderColumn>

            <TableHeaderColumn dataField="report_points" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='125'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.PontuacaoReportada}</TableHeaderColumn>

            <TableHeaderColumn dataField="actual_points" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='125'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.PontuacaoTotal}</TableHeaderColumn>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='70'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Checado}?</TableHeaderColumn>

            <TableHeaderColumn dataField="checked_at_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.DataDaChecagem}</TableHeaderColumn>

            <TableHeaderColumn dataField="action_plan" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='240'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.AcaoRealizada}</TableHeaderColumn>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={self.buttonActionPlan} width='80'>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Acoes}</TableHeaderColumn>

          </BootstrapTable>

          {/* Modal de Plano de Ação */}
          <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
            <Modal.Header>
              <h4 className="pull-left">{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tituloEditarPlanoDeAcao}</h4>
              <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
              <i className="fa fa-fw fa-close"></i></button>
              <div className="clearfix"></div>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={this.editActionPlan}>
                <input type="hidden" name="id" className="form-control" value={self.state.id} />
                <div className="form-group">
                  <label>{this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formularioEditarPlanoDeAcao.PlanoDeAcao}:</label>
                  <textarea style={{ height: 100}} className="form-control" type="text" name="action_plan" value={self.state.action_plan} onChange={self.handleChange.bind(self, 'action_plan')} />
                </div>     
                <div className="form-group">
                  <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formularioEditarPlanoDeAcao.botaoEditarPlanoDeAcao}</button>
                </div>
              </form>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
              <i className="fa fa-fw fa-close"></i></button>
            </Modal.Footer>
          </Modal>

        </div>
      : ""}
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportIncidentFatigueFilter;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportIncidentFatigueFilter.js